module.exports = __webpack_public_path__ + "static/img/upload_icon2.275c315c.png";